// extracted by mini-css-extract-plugin
module.exports = {"modalBtn":"styles_modalBtn__2ZV7o","file":"styles_file__1xhrm"};